// Function to convert GraphQL Relay ID to database ID
export function getIntegerId(globalId: string) {
    const decoded = atob(globalId);
    return Number(decoded.split(':')[1]);
}

export const getGlobalIdType = (globalId: string): string | null => {
    if (!globalId) {
        return null;
    }

    try {
        const decoded = atob(globalId);
        return decoded.split(':')[0] ?? null;
    } catch {
        return null;
    }
};

// Function to convert database ID to GraphQL Relay ID
export function toGlobalId(type: string, id: string | number): string {
    return btoa(`${type}:${id}`);
}

export const isBase64 = (str: string) => {
    if (!str) {
        return false;
    }
    try {
        return btoa(atob(str)) === str;
    } catch {
        return false;
    }
};
